import React from 'react';
import {
  BarChartOutlined,
  BarsOutlined,
  CalendarOutlined,
  FilterOutlined,
  InfoOutlined,
  LineChartOutlined,
  PieChartOutlined,
  RetweetOutlined,
  SettingOutlined,
  TeamOutlined,
  UserOutlined,
  WalletOutlined,
} from '@ant-design/icons';

import { staticPermissions } from './authorization';
import { LOCATION } from './location';
import { commonEvents } from './event';

// параметр advanced добавляет звездочку к названию
export const TABS = {
  DASHBOARDS: {
    location: LOCATION.DASHBOARDS,
    title: 'Dashboards',
    icon: <BarChartOutlined />,
    advanced: false,
    permission: [staticPermissions.METAINF_READ, staticPermissions.DASHBOARDS_READ],
    events: [],
  },
  SEGMENTS: {
    location: LOCATION.SEGMENTS,
    title: 'Segments',
    icon: <PieChartOutlined />,
    advanced: false,
    permission: [staticPermissions.SEGMENT_READ],
  },
  FUNNELS: {
    location: LOCATION.FUNNELS,
    title: 'Funnels',
    icon: <FilterOutlined />,
    advanced: false,
    permission: [staticPermissions.FUNNEL_READ],
  },
  RETENTION: {
    location: LOCATION.RETENTION,
    title: 'Retention',
    icon: <RetweetOutlined />,
    advanced: false,
    permission: [
      staticPermissions.REGISTER_FIRST_START_EXECUTE,
      staticPermissions.DAU_EXECUTE,
      staticPermissions.WAU_EXECUTE,
      staticPermissions.MAU_EXECUTE,
    ],
    events: [
      commonEvents.DAU,
      commonEvents.WAU,
      commonEvents.MAU,
      commonEvents.REGISTER_FIRST_START,
    ],
  },
  ADVANCED_RETENTION: {
    location: LOCATION.ADVANCED_RETENTION,
    title: 'Retention (complex)',
    icon: <RetweetOutlined />,
    advanced: true,
    permission: [staticPermissions.METAINF_READ],
  },

  USAGE: {
    location: LOCATION.USAGE,
    title: 'Usage',
    icon: <LineChartOutlined />,
    advanced: false,
    permission: [
      staticPermissions.DAU_EXECUTE,
      staticPermissions.WAU_EXECUTE,
      staticPermissions.MAU_EXECUTE,
      staticPermissions.SESSION_CLOSE_EXECUTE,
    ],
    events: [commonEvents.DAU, commonEvents.WAU, commonEvents.MAU, commonEvents.SESSION_CLOSE],
  },
  REVENUE: {
    location: LOCATION.REVENUE,
    title: 'Revenue',
    icon: <WalletOutlined />,
    advanced: false,
    permission: [staticPermissions.PAYMENT_EXECUTE, staticPermissions.DAU_EXECUTE],
    events: [commonEvents.DAU, commonEvents.PAYMENT],
  },
  EVENTS: {
    location: LOCATION.EVENTS,
    title: 'Events',
    icon: <BarsOutlined />,
    advanced: false,
    permission: [staticPermissions.METAINF_READ],
  },
  USERS: {
    location: LOCATION.USERS,
    title: 'Users',
    icon: <TeamOutlined />,
    advanced: false,
    permission: [staticPermissions.METAINF_READ],
  },

  ADVANCED_MAPPING: {
    location: LOCATION.ADVANCED_MAPPING,
    title: 'Mapping (manual)',
    icon: <SettingOutlined />,
    advanced: true,
    permission: [staticPermissions.METAINF_READ],
  },
  FIELDS: {
    location: LOCATION.FIELDS,
    title: 'Fields',
    icon: <InfoOutlined />,
    advanced: false,
    permission: [staticPermissions.METAINF_READ],
  },
  LABELS: {
    location: LOCATION.LABELS,
    title: 'Labels',
    icon: <CalendarOutlined />,
    advanced: false,
    permission: [staticPermissions.LABELS_READ],
  },
  AUTHORIZATION: {
    location: LOCATION.AUTHORIZATION,
    title: 'Authorization',
    icon: <UserOutlined />,
    advanced: false,
    permission: [staticPermissions.AUTHORIZATION_READ],
  },
};

// параметр advanced добавляет звездочку к названию
export const menuGroups = {
  dashboards: [TABS.DASHBOARDS],

  userInsights: [TABS.SEGMENTS, TABS.FUNNELS, TABS.RETENTION, TABS.ADVANCED_RETENTION],

  analytics: [TABS.USAGE, TABS.REVENUE, TABS.EVENTS, TABS.USERS],

  advanced: [TABS.ADVANCED_MAPPING, TABS.FIELDS, TABS.LABELS, TABS.AUTHORIZATION],
};
